import { Location } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { WatchAlert } from '@compumark/order-management-client';

import { CreateNewAlertComponent } from '../create-new-alert/create-new-alert.component';
import { AlertApiClientService } from '../services/alert-api-client.service';
import { AlertStateService } from '../services/alert-state.service';

@Component({
  selector: 'app-alert-actionbar',
  templateUrl: './alert-actionbar.component.html',
  styleUrls: ['./alert-actionbar.component.scss'],
  standalone: false,
})
export class AlertActionbarComponent implements OnInit {
  private alertApiClientService = inject(AlertApiClientService);
  private alertStateService = inject(AlertStateService);
  private location = inject(Location);
  private dialog = inject(MatDialog);
  private nativeWindow = inject<Window>('nativeWindow' as any);

  disableAll = false;

  ngOnInit(): void {
    this.alertApiClientService.isAlertConfigDisabled().subscribe((state) => {
      this.disableAll = state;
      this.alertStateService.setDisableAll(state);
    });
  }

  onToggleChange(value: boolean): void {
    this.alertApiClientService.disableAll(value).subscribe(() => {
      this.alertStateService.setDisableAll(value);
    });
  }

  back(): void {
    const preLoginReferrer = sessionStorage.getItem('preLoginReferrer');

    if (preLoginReferrer) {
      sessionStorage.removeItem('preLoginReferrer');
      this.nativeWindow.location.assign(preLoginReferrer);
      return;
    }

    this.location.back();
  }

  createNewAlertWindow(): MatDialogRef<CreateNewAlertComponent> {
    (document.activeElement as HTMLElement)?.blur();
    return this.dialog.open(CreateNewAlertComponent, {
      data: {} as WatchAlert,
      width: '65vw',
      height: '90vh',
      disableClose: true,
    });
  }
}
